import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  QaiButtonComponent,
  QaiButtonKind,
  QaiButtonSize,
  QaiFloatingDirective,
  QaiIconComponent,
  QaiIconKind,
  QaiMenuComponent,
  QaiMenuItemButtonComponent,
  QaiMenuSectionComponent,
} from '@qai/ui';

@Component({
  imports: [
    CommonModule,
    QaiIconComponent,
    QaiMenuComponent,
    QaiMenuSectionComponent,
    QaiMenuItemButtonComponent,
    QaiFloatingDirective,
    QaiButtonComponent,
  ],
  selector: 'button-floating-select',
  standalone: true,
  styleUrls: ['./button-floating-select.component.scss'],
  templateUrl: './button-floating-select.component.html',
})
export class ButtonFloatingSelectComponent {
  @Input() options: { label: string; value: string }[] = [];
  @Input() buttonLabel: string = 'Create new';
  @Input() buttonKind: QaiButtonKind = 'primary';
  @Input() buttonSize: QaiButtonSize = 'small';
  @Input() buttonIcon?: QaiIconKind; 
  @Output() optionSelected = new EventEmitter<string>();

  onMenuItemClick(value: string) {
    this.optionSelected.emit(value);
  }
}
